<template>
  <v-form ref="form" class="d-flex flex-row my-2 align-center">
    <div class="mx-2" :class="classForMode">
      <v-text-field
        v-if="editMode"
        v-model="retail"
        label="Price"
        prefix="$"
        outlined
        dense
        background-color="#FFF"
        hide-details="auto"
        @blur="makeMoney()"
        @input="emitUpdate()"
        :rules="rules"
      ></v-text-field>
      <span v-else>${{ retail }}</span>
    </div>
    <v-icon small>mdi-slash-forward</v-icon>
    <div class="mx-2" :class="classForMode">
      <v-combobox
        v-if="editMode"
        v-model="quantity"
        :items="boxSizes"
        outlined
        class="mx-2"
        label="Quantity"
        dense
        background-color="#FFF"
        hide-details="auto"
        @input="emitUpdate()"
        :rules="rules"
      ></v-combobox>
      <span v-else> {{ quantity }} pack</span>
    </div>

    <div>
      <v-btn
        icon
        color="red"
        @click="$emit('disable', index)"
        v-if="editMode && showRemoveBtn"
        tabindex="-1"
        ><v-icon small color="red" alt-text="remove row"
          >mdi-minus-circle</v-icon
        ></v-btn
      >
    </div>
    <div>
      <v-btn
        icon
        color="green"
        @click="$emit('addRow')"
        v-if="editMode && showAddBtn"
        tabindex="-1"
        ><v-icon small color="green" alt-text="add row"
          >mdi-plus-circle</v-icon
        ></v-btn
      >
    </div>
  </v-form>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "SetBrandPriceRow",
  props: {
    initialQuantity: null,
    initialRetail: null,
    index: null,
    editMode: null,
    boxSizes: null,
    showRemoveBtn: null,
    showAddBtn: null,
  },
  data: function () {
    return {
      quantity: null,
      retail: null,
      rules: [
        // (value) => !!value || "Required",
        (value) => !value || parseFloat(value) > 0 || "Must be > 0",
      ],
    };
  },
  methods: {
    makeMoney() {
      if (this.retail && this.retail > 0)
        this.retail = parseFloat(this.retail).toFixed(2);
      if (!this.retail) this.retail = null;
    },
    emitUpdate() {
      let q = this.quantity || null;
      let p = this.retail || null;
      this.$emit("update", {
        quantity: parseInt(q),
        retail: parseFloat(p),
        valid: this.validateField(),
      });
    },
    validateField() {
      return this.$refs.form.validate();
    },
  },
  computed: {
    classForMode: function () {
      return this.editMode ? "inputWidth" : "numberWidth";
    },
    quantityDescriptor: function () {
      let rtn = "";
      if (this.quantity > 1) rtn = ` / ${this.quantity}`;
      if (this.quantity == 1) rtn = " / lens";
      return rtn;
    },
  },
  watch: {
    initialQuantity(val) {
      this.quantity = val;
    },
    initialRetail(val) {
      this.retail = val;
    },
  },
  mounted() {
    if (this.initialQuantity) this.quantity = this.initialQuantity;
    if (this.initialRetail) this.retail = this.initialRetail;
  },
};
</script>

<style scoped>
.inputWidth {
  max-width: 125px;
}
.numberWidth {
  width: 70px;
  text-align: right;
}
</style>
